export default __webpack_public_path__ + "static/media/notify1.14da0230.svg";